import React from "react";

const Divider = () => {

    return (
        <div style={{ marginTop: '30px', marginBottom: '40px' }}>
            <div style={{ height: '1px', backgroundColor: "#FFFFFF", width: "90%", margin: "auto" }}></div>
        </div>
    );
}

export default Divider;